import { LifestyleCompletePageTemplateProps } from "./template";
import { useNavigate } from "react-router-dom";
import { PagePaths } from "../../../../types";

export const useLifestyleCompletePage = (): LifestyleCompletePageTemplateProps => {
    const navigate = useNavigate();

    // Here we need to redirect partners to the main dashboard. We'll need to fetch the new partner object

    const navigateToPage = (to: string) => {
        navigate(to);
    }

    const onReturnPressed = () => {
        navigate(-1);
    }

    const onSendEmails = () => {
        // Navigate to the lifestyle main page
        navigate(`/dashboard/${PagePaths.lifestyle}/main`, { replace: true });
    }

    return {
        navigateToPage,
        onReturnPressed,
        onSendEmails
    }
} 
